import React from 'react';

const CurvyBackgroundSVG = ({ height }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height={height} viewBox="0 0 1510 310" fill="none" preserveAspectRatio="none">
    <path d="M858 52.2161C498 -49.6986 200.667 20.7424 0 68.7022V310H1510V52.2166L1508.43 52.7138C1352.99 101.997 1202.45 149.728 858 52.2161Z" fill="#EDF4F7" />
  </svg>
);

export default CurvyBackgroundSVG;
